import type * as awsAmplifyAuth from 'aws-amplify/auth'

import type { Feature } from './feature'

export class Selectors {
  /**
   * @see {@link awsAmplifyAuth.AuthSession}
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly session

  /**
   * Flag indicating whether the user is logged in
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isLoggedIn

  /**
   * Error that occurred during authentication, if such an error occurred
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(feature: Feature) {
    this.session = feature.state.project(state => state.session)
    this.isLoggedIn = this.session.project(session => !!session)
    this.error = feature.state.project(state => state.error)
  }
}
